export default class ScrollToAnchor {
   constructor() {
      this.navbar = document.querySelector('.navbar')
      this.init()
   }

   init() {
      const navbarHeight = window.innerWidth > 1023 ? 80 : 60
      $(document).on('click', 'a[href^="#"]:not([href="#"])', function(e) {
         e.preventDefault()

         const section = $($(this).attr('href'))
         if (section.length > 0) {
            $('html, body').stop().animate({
               scrollTop: section.offset().top - navbarHeight
            }, 500, 'linear')
         }

         // if not front page -> redirect to home
         if (section.length == 0 && $(this).closest('.navbar__menu').length > 0) {
            window.location.href = '/' + $(this).attr('href')
         }
      })

      if (window.location.hash) {
         const hash = window.location.hash;
     
         if ($(hash).length) {
            setTimeout(() => {
               $('html, body').animate({
                  scrollTop: $(hash).offset().top - navbarHeight
               }, 500, 'linear')
            }, 100)
         }
      }
   }
}



//////////////////
// WEBPACK FOOTER
// ./js/components/scroll-to-anchor.js
// module id = 15
// module chunks = 0